import pxToRem from "../functions/pxToRem";

export default function sidenav({ colors }) {
  const { background } = colors;

  const sidenav = {
    styleOverrides: {
      root: {
        width: pxToRem(250),
        whiteSpace: "nowrap",
        border: "none",
      },

      paper: {
        width: pxToRem(250),
        backgroundColor: background.sidenav,
        height: "100vh",
        margin: 0,
        borderRadius: 0,
        border: "none",
      },

      paperAnchorDockedLeft: {
        borderRight: "none",
      },
    },
  };

  return sidenav;
}
